import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { FaultyDataItem, FaultyVehicleDataService, VehicleDataFieldEnum } from '../../../service/FaultyVehicleData.service';

@Component({
    selector: 'app-faulty-vehicle-data-table',
    templateUrl: './faulty-vehicle-data-table.component.html',
    styleUrl: './faulty-vehicle-data-table.component.css'
})
export class FaultyVehicleDataTableComponent {

    faultyVehicleDataService = inject(FaultyVehicleDataService);

    faultyDataList = input.required<FaultyDataItem[]>();

    @Output() faultyValueSelected = new EventEmitter<string>();

    selectedValue = input<string | null>(null);

    private fieldLabels = {
        [VehicleDataFieldEnum.ECU_BUILD]: 'ECU Builds',
        [VehicleDataFieldEnum.VEHICLE_PRODUCER]: 'Vehicle Producers',
        [VehicleDataFieldEnum.VEHICLE_TYPE]: 'Vehicle Types',
        [VehicleDataFieldEnum.ECU_PRODUCER]: 'ECU Producers',
    };

    selectFaultyValue(item: FaultyDataItem) {
        this.faultyValueSelected.emit(item.value);
    }

    getTableHeaderName(): string {
        return this.fieldLabels[this.faultyVehicleDataService.selectedField()] || 'Faulty Data';
    }
}
